import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { HomeComponent } from './features/home/home.component';

const routes: Routes = [
  // Embed routes (no layout, no auth)
  {
    path: 'embed',
    loadChildren: () => import('./features/embed/embed.module').then(m => m.EmbedModule)
  },
  // Unauthorized page
  {
    path: 'unauthorized',
    loadComponent: () => import('./features/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  // Login failed page
  {
    path: 'login-failed',
    loadComponent: () => import('./features/login-failed/login-failed.component').then(m => m.LoginFailedComponent)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'events',
        loadChildren: () => import('./features/events/events.module').then(m => m.EventsModule)
      },
      {
        path: 'sports',
        loadChildren: () => import('./features/sports/sports.module').then(m => m.SportsModule)
      },
      {
        path: 'federations',
        loadChildren: () => import('./features/federations/federations.module').then(m => m.FederationsModule)
      },
      {
        path: 'clubs',
        loadChildren: () => import('./features/clubs/clubs.module').then(m => m.ClubsModule)
      },
      {
        path: 'members',
        loadChildren: () => import('./features/members/members.module').then(m => m.MembersModule)
      },
      {
        path: 'teams',
        loadChildren: () => import('./features/teams/teams.module').then(m => m.TeamsModule)
      },
      {
        path: 'tournaments',
        loadChildren: () => import('./features/tournaments/tournaments.module').then(m => m.TournamentsModule)
      },
      {
        path: 'competitions',
        loadChildren: () => import('./features/competitions/competitions.module').then(m => m.CompetitionsModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
